<template>
<div class="chapter">
<div class="inner_page">
<p class="C69"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="C75"><a id="page_vii"></a><a href="#/xhtml/05_Preface_#page_ix">Preface: Even Detroit</a></p>
<p class="C76"><a href="#/xhtml/06_1__What#page_1">1. What We’ve Lost—and Why</a></p>
<p class="C76"><a href="#/xhtml/07_2__Fleei#page_15">2. Fleeing Robin Hood</a></p>
<p class="C76"><span href="#/xhtml/08_3__A_1_P#page_29" title="Link target outside of Sample">3. A 1-Percent Solution</span></p>
<p class="C76"><span href="#/xhtml/09_4__The_C#page_48" title="Link target outside of Sample">4. The Conquest of Capital</span></p>
<p class="C76"><span href="#/xhtml/10_5__A_Bet#page_66" title="Link target outside of Sample">5. A Better Climate</span></p>
<p class="C76"><span href="#/xhtml/11_6__Thing#page_83" title="Link target outside of Sample">6. Things Fall Apart</span></p>
<p class="C76"><span href="#/xhtml/12_7__Three#page_100" title="Link target outside of Sample">7. Three Simple Rules</span></p>
<p class="C76"><span href="#/xhtml/13_8__No_Li#page_117" title="Link target outside of Sample">8. No Little Plans</span></p>
<p class="C76"><span href="#/xhtml/14_9__Contr#page_136" title="Link target outside of Sample">9. Control Freaks</span></p>
<p class="C76"><span href="#/xhtml/15_10__Recl#page_155" title="Link target outside of Sample">10. Reclaiming the Commons</span></p>
<p class="C75"><span href="#/xhtml/16_11__Boom#page_173" title="Link target outside of Sample">11. Boom Commandments</span></p>
<p class="C76"><span href="#/xhtml/17_Acknowle#page_189" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="C76"><span href="#/xhtml/18_Notes#page_191" title="Link target outside of Sample">Notes</span></p>
<p class="C76"><span href="#/xhtml/19_Index#page_201" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?fce8f0e6